/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneBase,
  PhoneBaseOptional,
  PhoneBaseMetaI,
  PhoneBaseTrackedI,
} from "./phone-base";
import { PhoneBaseTracked, PhoneBaseMeta } from "./phone-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneRef,
  PhoneRefOptional,
  PhoneRefMetaI,
  PhoneRefTrackedI,
} from "./phone-ref";
import { PhoneRefTracked, PhoneRefMeta } from "./phone-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneType,
  PhoneTypeOptional,
  PhoneTypeMetaI,
  PhoneTypeTrackedI,
} from "./phone-type";
import { PhoneTypeTracked, PhoneTypeMeta } from "./phone-type";

/**
 *
 * @export
 * @interface Phone
 */
export interface PhoneOptional extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  number?: string;
  /**
   *
   * @type {PhoneType}
   * @memberof Phone
   */
  type?: PhoneType;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isBad?: boolean;
}

export interface Phone extends PhoneOptional, Deletable, PhoneBase, PhoneRef {
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  number: string;
  /**
   *
   * @type {PhoneType}
   * @memberof Phone
   */
  type?: PhoneType;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isBad?: boolean;
}

export interface PhoneTrackedI extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  number?: string;
  numberIsSet: boolean;
  /**
   *
   * @type {PhoneType}
   * @memberof Phone
   */
  type?: PhoneType;
  typeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isVerified?: boolean;
  isVerifiedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Phone
   */
  isBad?: boolean;
  isBadIsSet: boolean;
}

transformDatesMap.set("Phone", function (model: Phone) {});

export type PhoneMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  number: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  type: PropertyMeta<PhoneTypeMetaI>;
  //isDate: false
  //isDatetime: false
  isVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isBad: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PhoneMeta: PhoneMetaI = {} as PhoneMetaI;
PhoneMeta = typeMeta("Phone", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  number: propertyMeta("number", false, true, false, MetaTypesBase.string),
  type: propertyMeta("type", false, false, false, PhoneTypeMeta),
  isVerified: propertyMeta(
    "isVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isBad: propertyMeta("isBad", false, false, false, MetaTypesBase.boolean),
});

const metaI = PhoneMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PhoneRefMeta]);
  metaI.assignId.inheritedFrom = PhoneRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([PhoneBaseMeta]);
  metaI.number.inheritedFrom = PhoneBaseMeta.number;
  metaI.type.inheritedFrom = PhoneBaseMeta.type;
  metaI.isVerified.inheritedFrom = PhoneBaseMeta.isVerified;
  metaI.isBad.inheritedFrom = PhoneBaseMeta.isBad;
});

export class PhoneTracked extends DeletableTracked implements PhoneTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  number__I?: string = undefined;
  numberIsSet: boolean = false;
  set number(v: undefined | string) {
    if (v !== undefined) {
      this.number__I = v;
      this.numberIsSet = true;
    } else {
      this.number__I = v || undefined;
      this.numberIsSet = true;
    }
    this.changeTracker = true;
  }
  get number() {
    return this.number__I;
  }
  type__I?: PhoneType = undefined;
  typeIsSet: boolean = false;
  set type(v: undefined | PhoneType) {
    if (v !== undefined) {
      this.type__I = v;
      this.typeIsSet = true;
    } else {
      this.type__I = v || undefined;
      this.typeIsSet = false;
    }
    this.changeTracker = true;
  }
  get type() {
    return this.type__I;
  }
  isVerified__I?: boolean = undefined;
  isVerifiedIsSet: boolean = false;
  set isVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.isVerified__I = v;
      this.isVerifiedIsSet = true;
    } else {
      this.isVerified__I = v || undefined;
      this.isVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isVerified() {
    return this.isVerified__I;
  }
  isBad__I?: boolean = undefined;
  isBadIsSet: boolean = false;
  set isBad(v: undefined | boolean) {
    if (v !== undefined) {
      this.isBad__I = v;
      this.isBadIsSet = true;
    } else {
      this.isBad__I = v || undefined;
      this.isBadIsSet = false;
    }
    this.changeTracker = true;
  }
  get isBad() {
    return this.isBad__I;
  }
  constructor(config?: PhoneOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(config: PhoneOptional, options?: AssignOptions): PhoneTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.number && this.numberApplyFilter(optionsRequired.filter)) {
      this.number = config.number;
      if (optionsRequired.unassign) this.numberIsSet = false;
      else this.numberIsSet = true;
    }
    if (config.type && this.typeApplyFilter(optionsRequired.filter)) {
      this.type = config.type;
      if (optionsRequired.unassign) this.typeIsSet = false;
      else this.typeIsSet = true;
    }
    if (
      config.isVerified &&
      this.isVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.isVerified = config.isVerified;
      if (optionsRequired.unassign) this.isVerifiedIsSet = false;
      else this.isVerifiedIsSet = true;
    }
    if (config.isBad && this.isBadApplyFilter(optionsRequired.filter)) {
      this.isBad = config.isBad;
      if (optionsRequired.unassign) this.isBadIsSet = false;
      else this.isBadIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PhoneTrackedI {
    const cloned = {} as PhoneTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.numberIsSetDeep() &&
      this.numberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.numberIsSet = true;
      cloned.number = this.number;
    } else {
      //cloned.numberIsSet = false
    }
    if (
      this.typeIsSetDeep() &&
      this.typeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIsSet = true;
      cloned.type = this.type;
    } else {
      //cloned.typeIsSet = false
    }
    if (
      this.isVerifiedIsSetDeep() &&
      this.isVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isVerifiedIsSet = true;
      cloned.isVerified = this.isVerified;
    } else {
      //cloned.isVerifiedIsSet = false
    }
    if (
      this.isBadIsSetDeep() &&
      this.isBadApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isBadIsSet = true;
      cloned.isBad = this.isBad;
    } else {
      //cloned.isBadIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PhoneTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.numberApplyFilter(filter)) this.numberIsSet = false;

    if (!this.typeApplyFilter(filter)) this.typeIsSet = false;

    if (!this.isVerifiedApplyFilter(filter)) this.isVerifiedIsSet = false;

    if (!this.isBadApplyFilter(filter)) this.isBadIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.assignId, PhoneMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.isDeleted, PhoneMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.isNew, PhoneMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  numberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.number, PhoneMeta, this.number, this);
  }
  numberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.numberIsSet && this.numberApplyFilter(filter)) return true;

    return false;
  }
  typeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.type, PhoneMeta, this.type, this);
  }
  typeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIsSet && this.typeApplyFilter(filter)) return true;

    return false;
  }
  isVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.isVerified, PhoneMeta, this.isVerified, this);
  }
  isVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isVerifiedIsSet && this.isVerifiedApplyFilter(filter)) return true;

    return false;
  }
  isBadApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneMeta.isBad, PhoneMeta, this.isBad, this);
  }
  isBadIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isBadIsSet && this.isBadApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.numberIsSetDeep(filter)) return true;
    if (this.typeIsSetDeep(filter)) return true;
    if (this.isVerifiedIsSetDeep(filter)) return true;
    if (this.isBadIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
